import { filterCasePartiesByRole, getCasePartyIdAndName } from './utils';

export default [
  {
    id: 'caseData',
    name: 'بيانات عامة عن الدعوى',
    inRoot: true,
    executer: lawsuitRequest => Object.keys(((lawsuitRequest || {}).case || {})).reduce((pv, cv) => {
      if (typeof (lawsuitRequest).case[cv] !== 'object' && typeof (lawsuitRequest).case[cv] !== 'function')
        pv[cv] = (lawsuitRequest).case[cv];
      return pv;
    }, {}),
    example:
    {
      courtId: 2,
      caseClassificationIdNew: 1,
      caseCategoryId: 103,
      caseTypeId: 10184,
      isReconciledBefore: true,
      reconciliationLocationId: 1,
      reconciliationRequestCode: '01-123456789',
    },
  },
  {
    id: 'caseParties',
    name: 'أطراف الدعوى',
    executer: lawsuitRequest => ((lawsuitRequest || {}).caseParties || []).map(getCasePartyIdAndName),
    example: [{
      id: 1000,
      name: 'المدعي الأول',
    }, {
      id: 2000,
      name: 'المدعي الثاني',
    }, {
      id: 3000,
      name: 'المدعى عليه الأول',
    }],
  },
  {
    id: 'prosecutors',
    name: 'المدعين',
    executer: lawsuitRequest => filterCasePartiesByRole(((lawsuitRequest || {}).caseParties || []), 'prosecutor')
      .map(getCasePartyIdAndName),
    example: [{
      id: 1000,
      name: 'المدعي الأول',
    }, {
      id: 2000,
      name: 'المدعي الثاني',
    }],
  },
  {
    id: 'defendants',
    name: 'المدعى عليهم',
    executer: lawsuitRequest => filterCasePartiesByRole(((lawsuitRequest || {}).caseParties || []), 'defendant')
      .map(getCasePartyIdAndName),
    example: [{
      id: 3000,
      name: 'المدعى عليه الأول',
    }],
  },
  {
    id: 'formGrids',
    name: 'جدول من نموذج الدعوى',
    isParent: true,
    executer: (lawsuitRequest) => {
      const form = (((lawsuitRequest || {}).case || {}).forms || [])[0];
      if (form)
        return {
          ...extractArrayValuesFromObject(form),
          ...(form.requests || []).reduce((pv, cv) => ({
            ...pv,
            ...extractArrayValuesFromObject(cv),
          }), {}),
        };
      else return {};
    },
    example: [],
  },
];

const extractArrayValuesFromObject = obj => Object.keys(obj)
  .reduce((pv2, cv2) => (Array.isArray(obj[cv2]) ? {
    ...pv2,
    [cv2]: obj[cv2],
  } : pv2), {});
